/** Fixed physical materials for illustrated medals, independent of the app theme. */
export const MEDAL_INLAY = { metal: "#2D999A", light: "#9CDAD0", unearned: "#999999" } as const;

export const STREAK_FINISHES = [
  { enamel: "#673F31", shadow: "#392822", metal: "#BC8A62", light: "#F5D1A4" },
  { enamel: "#245B67", shadow: "#123F48", metal: "#BED4D9", light: "#E5F0E9" },
  { enamel: "#34545C", shadow: "#203D44", metal: "#DFB567", light: "#F7E3AC" },
  { enamel: "#534778", shadow: "#302849", metal: "#BBC9EA", light: "#ECE5FA" },
] as const;

export const MEDAL_FINISHES = {
  waypoint: { enamel: "#247F82", shadow: "#12484F", metal: "#B3CECA", light: "#EDF4E9" },
  completion: { enamel: "#204955", shadow: "#102D38", metal: "#C79A4D", light: "#F5E8BC" },
  weekend: { enamel: "#685084", shadow: "#372A50", metal: "#C8AC75", light: "#F5E8CC" },
  streak: STREAK_FINISHES[0],
} as const;

export const SCENIC_MEDAL_FINISHES = {
  bronze: { metal: "#BA865B", light: "#F4D8B3" },
  warm: { metal: "#C5AC80", light: "#F6E6C8" },
  unearned: { enamel: "#777777", shadow: "#414141", metal: "#A8A8A8", light: "#DFDFDF" },
} as const;
